export const getPaddingForSide = (side, padding, fallback) => {
    if (typeof padding == 'number') {
        return padding;
    }
    else if (typeof padding == 'object' && Object.keys(padding).length > 0) {
        return padding[side] || 0;
    }
    return getPaddingForSide(side, fallback, 0);
};
//# sourceMappingURL=chart-padding.js.map